import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import LabelField from "./labelField";
import { useDispatch } from "react-redux";
import SquareCheckBox from "./SquareCheckBox";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { getExamListNew } from "../Action/courseAction";

function ExamNamePopUp(props) {
  const dispatch = useDispatch();
  const [examList, setExamList] = useState([]);
  const [exam, setExam] = useState(null);
  const [allSelectedExamList, setAllSelectedExamList] = useState([]);
  const hasSyncedRef = useRef(false);

  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        const tempExam = res?.map((item) => ({
          _id: item?._id,
          name: item?.name,
          isSelected: false,
          baseCourseId:
            item?.baseCourseId?.map((sub) => ({
              _id: sub?._id,
              name: sub?.name,
              isSelected: false,
            })) || [],
        }));
        setExamList(tempExam);
        setExam(null);
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (
      !props.open ||
      hasSyncedRef.current ||
      !props.selectedList ||
      examList.length === 0
    )
      return;

    const updated = examList.map((ex) => {
      const sel = props.selectedList.filter((s) => s.examId === ex._id);

      const updatedBase = ex.baseCourseId.map((bc) => ({
        ...bc,
        isSelected: sel.some((s) => s.baseCourseId === bc._id),
      }));

      return {
        ...ex,
        baseCourseId: updatedBase,
        isSelected: updatedBase.some((b) => b.isSelected),
      };
    });

    setExamList(updated);

    const examToOpen = updated.find((ex) =>
      ex.baseCourseId.some((bc) => bc.isSelected),
    );

    if (examToOpen) {
      setExam(examToOpen);
    }

    hasSyncedRef.current = true;
  }, [props.open, props.selectedList, examList.length]);

  useEffect(() => {
    if (props.open) {
      hasSyncedRef.current = false;
    }
  }, [props.open]);

  const onSelectExam = (event, index) => {
    const isChecked = event.target.checked;
    const newArray = examList.map((examItem, i) => {
      if (i === index) {
        return {
          ...examItem,
          isSelected: isChecked,
          baseCourseId: examItem.baseCourseId.map((bc) => ({
            ...bc,
            isSelected: isChecked,
          })),
        };
      }
      return examItem;
    });
    setExamList(newArray);
    setExam(newArray[index]);

    updateSelected(newArray);
  };
  const onSelectExamStream = (event, index, selectedExam) => {
    const newArray = examList.map((ex) => {
      if (ex._id === selectedExam._id) {
        const updated = ex.baseCourseId.map((bc, i) =>
          i === index ? { ...bc, isSelected: event.target.checked } : bc,
        );

        return {
          ...ex,
          baseCourseId: updated,
          isSelected: updated.some((b) => b.isSelected),
        };
      }
      return ex;
    });

    setExamList(newArray);
    setExam(newArray.find((e) => e._id === selectedExam._id));

    updateSelected(newArray);
  };

  const updateSelected = (updated) => {
    const allSelected = updated.flatMap((ex) => {
      if (!ex.baseCourseId || ex.baseCourseId.length === 0) {
        return ex.isSelected
          ? [
              {
                examId: ex._id,
                examName: ex.name,
                baseCourseId: null,
                baseCourseName: null,
              },
            ]
          : [];
      }
      return ex.baseCourseId
        .filter((bc) => bc.isSelected)
        .map((bc) => ({
          examId: ex._id,
          examName: ex.name,
          baseCourseId: bc._id,
          baseCourseName: bc.name,
        }));
    });

    setAllSelectedExamList(allSelected);
    props.onSelectExams(allSelected);
  };
  // Add these two handlers after your existing handlers:

  const onSelectAllExams = (event) => {
    const isChecked = event.target.checked;
    const newArray = examList.map((examItem) => ({
      ...examItem,
      isSelected: isChecked,
      baseCourseId: examItem.baseCourseId.map((bc) => ({
        ...bc,
        isSelected: isChecked,
      })),
    }));
    setExamList(newArray);
    setExam(null);
    updateSelected(newArray);
  };

  const onSelectAllStreams = (event) => {
    const isChecked = event.target.checked;
    const newArray = examList.map((ex) => {
      if (ex._id === exam._id) {
        return {
          ...ex,
          baseCourseId: ex.baseCourseId.map((bc) => ({
            ...bc,
            isSelected: isChecked,
          })),
          isSelected: isChecked,
        };
      }
      return ex;
    });
    setExamList(newArray);
    setExam(newArray.find((e) => e._id === exam._id));
    updateSelected(newArray);
  };
  return (
    <Modal
      className="model"
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={props.open}>
        <div className="bg-white rounded-4 shadow p-4 w-100" style={{ maxWidth: "850px", margin: "auto" }}>
  <form>
    {/* Header */}
    <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
      <h5 className="fw-semibold text-dark mb-0">
        Exam Name & Exam Stream
      </h5>
      <ClearOutlinedIcon
        className="text-secondary cursor-pointer"
        onClick={props.handleClose}
      />
    </div>

    {/* Exam Section */}
    <div className="row g-3">
      <div className="col-md-6">
        <LabelField labelName={"Exam Name"} isRequired />

        {examList?.length > 0 && (
          <div className="card shadow-sm border-0 mt-2">
            {/* Select All */}
            <div className="d-flex align-items-center px-3 py-2 border-bottom bg-light">
              <SquareCheckBox
                id="select-all-exams"
                checked={
                  examList.length > 0 &&
                  examList.every((e) => e.isSelected)
                }
                onChange={onSelectAllExams}
              />
              <span className="ms-2 fw-medium">Select All</span>
            </div>

            {/* Exam List */}
            <div className="overflow-auto" style={{ maxHeight: "450px" }}>
            {examList.map((c, index) => (
              <div
                key={c._id}
                className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom font12"
              >
                <SquareCheckBox
                  id={c._id}
                  value={c.name}
                  checked={c.isSelected}
                  onChange={(e) => onSelectExam(e, index)}
                />

                <div
                  className="d-flex justify-content-between align-items-center w-100 ms-2 cursor-pointer font12"
                  onClick={() =>
                    setExam(examList.find((ex) => ex._id === c._id))
                  }
                >
                  <span
                    className={
                      c._id === exam?._id
                        ? "fw-semibold text-primary"
                        : ""
                    }
                  >
                    {c.name}
                  </span>

                  <RemoveRedEyeIcon
                    fontSize="small"
                    className={
                      c._id === exam?._id
                        ? "text-primary"
                        : "text-muted"
                    }
                    style={{ fontSize: 18 }}
                  />
                </div>
              </div>
            ))}
          </div>
          </div>
        )}
      </div>

      {/* Stream Section */}
      
      {exam?.baseCourseId?.length > 0 && (
        <div className="col-md-6">
          <LabelField labelName={"Exam Stream"} />

          <div className="card shadow-sm border-0 mt-2">
            {/* Select All */}
            <div className="d-flex align-items-center px-3 py-2 border-bottom bg-light">
              <SquareCheckBox
                id="select-all-streams"
                checked={exam.baseCourseId.every((bc) => bc.isSelected)}
                onChange={onSelectAllStreams}
              />
              <span className="ms-2 fw-medium">Select All</span>
            </div>

            {/* Stream List */}
            <div className="overflow-auto" style={{ maxHeight: "450px" }}>
            {exam.baseCourseId.map((c, index) => (
              <div
                key={c._id}
                className="d-flex align-items-center px-3 py-2 border-bottom font12"
              >
                <SquareCheckBox
                  id={c._id}
                  value={c.name}
                  checked={c.isSelected}
                  onChange={(e) =>
                    onSelectExamStream(e, index, exam)
                  }
                  labelName={c.name}
                />
              </div>
            ))}
          </div>
          </div>
        </div>
      )}
    </div>
  </form>
</div>
      </Fade>
    </Modal>
  );
}

export default ExamNamePopUp;
